import React from 'react';

const Footer = () => {
  return (
    <footer className="relative bg-contribo-navy text-white py-6 mt-auto">
      <div className="max-w-md mx-auto px-4">
        {/* Mobile-Optimized Layout (360px width friendly) */}
        <div className="flex flex-col items-center space-y-4">
          {/* Logo - Smaller for mobile */}
          <div className="flex-shrink-0">
            <img 
              src="https://customer-assets.emergentagent.com/job_contribo-events/artifacts/34asmsa6_Logo%20design%20for%20Quad.png" 
              alt="Quad A Technologies" 
              className="h-16 w-auto opacity-90"
            />
          </div>
          
          {/* Center Content */}
          <div className="flex flex-col items-center space-y-2 w-full">
            {/* Company Name */}
            <p className="text-contribo-gold font-bold text-lg text-center">
              Quad A Technologies
            </p>
            
            {/* Tagline */}
            <p className="text-contribo-gold text-xs text-center">
              RSVP → Blessing → Contribution → Celebration
            </p>
            
            {/* Copyright */}
            <p className="text-gray-300 text-xs text-center">
              © 2026 Contribo. All rights reserved.
            </p>
            
            {/* Support Email */}
            <div className="flex flex-col items-center space-y-1 text-center">
              <span className="text-gray-300 text-xs">For help/suggestions:</span>
              <a 
                href="mailto:support@contribo.in" 
                className="text-contribo-gold hover:text-contribo-gold-light underline text-xs break-all"
              >
                support@contribo.in
              </a>
            </div>
            
            {/* Social Media Links */}
            <div className="flex items-center justify-center space-x-4 pt-2">
              <a 
                href="https://x.com/contribo_in" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-contribo-gold transition-colors"
                aria-label="Follow us on X (Twitter)"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a 
                href="https://www.linkedin.com/in/contribo-in-8a1b15399/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-contribo-gold transition-colors"
                aria-label="Connect with us on LinkedIn"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
